import { connect } from 'react-redux';

import type { Dispatch } from 'redux';

import type { DateRange, Sort, UUID } from '@cobliteam/common-types';

import type { Checklist, ChecklistsNames, ChecklistsPage as ChecklistsPageType, NewChecklist, UpdatedChecklist, WebData } from '@cobliteam/api-lib';

import ChecklistsPage from '../../components/ChecklistsPage';

import {
  createChecklistRequest,
  deleteChecklistRequest,
  loadCompletedChecklistsNamesRequest,
  loadCompletedChecklistsRequest,
  loadTemplateChecklistsRequest,
  selectChecklistsNamesWebData,
  selectCompletedChecklistsWebData,
  selectDeleteChecklistWebData,
  selectSaveChecklistWebData,
  selectTemplateChecklistsWebData,
  updateChecklistRequest,
} from '../../store';
import type { ChecklistsState } from '../../store/checklistsStore';

type OwnProps = {};

interface StateProps {
  templateChecklistsWebData: WebData<ChecklistsPageType>;
  completedChecklistsWebData: WebData<ChecklistsPageType>;
  completedChecklistsNamesWebData: WebData<ChecklistsNames>;
  saveChecklistWebData: WebData<void>;
  deleteChecklistWebData: WebData<void>;
}

interface DispatchProps {
  loadCompletedChecklists: (period?: DateRange, page?: number, size?: number, sort?: Sort, inputFilter?: string, nameFilters?: string[]) => void;
  loadTemplateChecklists: () => void;
  createChecklist: (createdChecklist: NewChecklist) => void;
  loadCompletedChecklistsNames: () => void;
  updateChecklist: (id: UUID, updatedChecklist: UpdatedChecklist) => void;
  deleteChecklist: (deletedChecklist: Checklist) => void;
}

const mapStateToProps = (state: ChecklistsState): StateProps => ({
  templateChecklistsWebData: selectTemplateChecklistsWebData(state),
  completedChecklistsWebData: selectCompletedChecklistsWebData(state),
  completedChecklistsNamesWebData: selectChecklistsNamesWebData(state),
  saveChecklistWebData: selectSaveChecklistWebData(state),
  deleteChecklistWebData: selectDeleteChecklistWebData(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  loadCompletedChecklists: (period?: DateRange, page?: number, size?: number, sort?: Sort, inputFilter?: string, nameFilters?: string[]) => {
    dispatch(loadCompletedChecklistsRequest(period, page, size, sort, inputFilter, nameFilters));
  },

  loadTemplateChecklists: () => {
    dispatch(loadTemplateChecklistsRequest());
  },

  loadCompletedChecklistsNames: () => {
    dispatch(loadCompletedChecklistsNamesRequest());
  },
  createChecklist: (createdChecklist: NewChecklist) => {
    dispatch(createChecklistRequest(createdChecklist));
  },
  updateChecklist: (id: UUID, updatedChecklist: UpdatedChecklist) => {
    dispatch(updateChecklistRequest(id, updatedChecklist));
  },
  deleteChecklist: (deletedChecklist: Checklist) => {
    dispatch(deleteChecklistRequest(deletedChecklist));
  },
});

export default connect<StateProps, DispatchProps, OwnProps, ChecklistsState>(mapStateToProps, mapDispatchToProps)(ChecklistsPage);
